// src/pages/merchant-pages/ShippedContainerSlider.js
import React from "react";
import Slider from "react-slick";
import Card from "./ShippedContainerCard";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import SVG icons
import Icon2 from "../assets/cardIcons/2.svg";
import Icon3 from "../assets/cardIcons/3.svg";
import Icon4 from "../assets/cardIcons/4.svg";
import Icon5 from "../assets/cardIcons/5.svg";
import Icon6 from "../assets/cardIcons/6.svg";
import Icon8 from "../assets/cardIcons/8.svg";

const icons = [Icon2, Icon3, Icon4, Icon5, Icon6, Icon8];

const getRandomNumber = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const ShippedContainerSlider = () => {
  const numCards = getRandomNumber(4, 10); // Random number of cards
  const cards = Array.from({ length: numCards }, (_, index) => ({
    containerNumber: `CNT-${getRandomNumber(1000, 9999)}`,
    amount: getRandomNumber(500, 5000),
    icon: icons[getRandomNumber(0, icons.length - 1)],
  }));

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Slider {...settings}>
      {cards.map((card, index) => (
        <div key={index} style={{ padding: "10px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Card
              containerNumber={card.containerNumber}
              amount={card.amount}
              src={card.icon}
            />
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default ShippedContainerSlider;
